import { YesNoIndicators } from '../../../../../global/models/api-model';

export enum RelationshipType {
	Father = 'Father',
	Mother = 'Mother',
	Domestic = 'Domestic Partner',
	Other = 'Other Beneficiary',	
	Spouse = 'Spouse',	
	Child = 'Child',
	StepChild = 'Stepchild',
	FormerSpouse = 'Former Spouse',	
}
export enum BeneficiaryType {
	Person = 'person',
	Entity = 'entity',
	Estate = 'estate',
	Trust = 'trust',
}

export interface BeneficiaryCreateFormModel {

	beneficiary_type: BeneficiaryType;
	relationship: RelationshipType;
	first_name: string;
	middle_name: string;
	last_name: string;
	suffix: string;
	perferred_name: string;
	gender: string;
	date_of_birth: string;
	tax_id: string;
	mailing_country: string;
	mailing_address_1: string;
	mailing_address_2: string;
	mailing_address_3: string;
	mailing_city: string;
	mailing_state: string;
	mailing_postal_code: string;
	same_address: boolean;
	business_phone_country_code: string;
	business_phone_area_code: string;
	business_phone_number: string;
	business_phone_formated: string;
	business_phone_extension: string;
	home_phone_country_code: string;
	home_phone_area_code: string;
	home_phone_number: string;
	home_phone_formated: string;
	home_phone_extension: string;
	mobile_phone_country_code: string;
	mobile_phone_area_code: string;
	mobile_phone_number: string;
	mobile_phone_formated: string;
	mobile_phone_extension: string;
	office_email_address: string;
	personal_email_address: string;
	org_name: string;
	contact_first_name: string;
	contact_last_name: string;
	contact_phone: string;
	contact_email: string;
	acknowledge: boolean;
	disabled_child_indicator?: YesNoIndicators;
	designation_salutation: string;
	gender_identity: string;
	gender_identity_other: string;	
}

export interface CreateOrganizationFormContentModel {
	title: string;
	description: string;
	legalNameLabel: string;
	legalNameHelperText: string;
	personTitle: string;

}
  
  export interface ObjectPersonAttributes {
	designation_salutation: string;	
	first_name: string;
	middle_name: string;
	last_name: string;
	preferred_name: string;
	gender: string;
	date_of_birth: string;
	suffix: string;
	ssn: string;
	mailing_address_attributes: MailingAddressAttributes;
	personal_email_attributes: EmailAttributes;	
	mobile_number_attributes: MobileNumberAttributes;
	home_number_attributes: HomeNumberAttributes;
	disabled_child_indicator: string;	
  }
  
  export interface MailingAddressAttributes {
	country: string;
	address1: string;
	address2: string;
	address3: string;
	city: string;
	state: string;
	postal_code: string;
	o_location_id?: any;
  }
  
  export interface EmailAttributes {
	email_address: string;
  }
  
  export interface MobileNumberAttributes {
	phone_country_code: string;
	phone_area_code: string;
	phone_number: string;
	phone_extension: string;
  }
  
  export interface HomeNumberAttributes {
	phone_country_code: string;
	phone_area_code: string;
	phone_number: string;
	phone_extension: string;
  }  

  export interface RelationshipOrganization {
	relationship_code: string;
	object_organization_attributes: {
	  report_name: string;
	  tax_id: string;
	  business_address_attributes: {
		address1: string;
		address2: string;
		state: string;
		city: string;
		postal_code: string;
		country: string;
	  };
	};
  }

  export interface RelationshipPerson {
	relationship_code: string;	
	object_person_attributes: ObjectPersonAttributes
  }
  
  export interface BeneficiaryOrganizationType {
	organization_type: string;
	contact_person: string;
	contact_phone: string;
	contact_email: string;
  }

  export interface RelationshipPersonRequest {
	relationship: RelationshipPerson;
  }
  
  export interface RelationshipOrganizationRequest {	
	relationship: RelationshipOrganization;
	beneficiary_organization_type: BeneficiaryOrganizationType;
  }
  